import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { TenantOnboardingComponent } from './tenant-onboarding.component';
import { CreateTenantNewComponent } from '../tenants-mgmt/create-tenant-new/create-tenant-new.component';

const routes: Routes = [
  {
    path: '',
    component: TenantOnboardingComponent,
    title: 'Tenant'
  },
  {
    path: 'create',
    component: CreateTenantNewComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantOnboardingRoutingModule {
}
